import { useState } from 'react';
import { EmailConfirmationModal, EmailRecipient } from '~/components/common/email-confirmation-modal';

interface UseEmailConfirmationOptions {
  actionDescription: string; // e.g., "Assigning staff to service ticket"
  onProceed: (sendEmails: boolean) => void | Promise<void>;
}

export function useEmailConfirmation() {
  const [isOpen, setIsOpen] = useState(false);
  const [recipients, setRecipients] = useState<EmailRecipient[]>([]);
  const [actionDesc, setActionDesc] = useState('');
  const [onProceedCallback, setOnProceedCallback] = useState<(sendEmails: boolean) => void | Promise<void>>(() => {});
  const [loading, setLoading] = useState(false);

  const showConfirmation = (
    recipientList: EmailRecipient[],
    options: UseEmailConfirmationOptions,
  ) => {
    setRecipients(recipientList);
    setActionDesc(options.actionDescription);
    setOnProceedCallback(() => options.onProceed);
    setIsOpen(true);
  };

  const handleConfirm = async (sendEmails: boolean) => {
    setLoading(true);
    try {
      await onProceedCallback(sendEmails);
      setIsOpen(false);
    } catch (error) {
      console.error('Error in email confirmation callback:', error);
      // Don't close modal on error so user can see what happened
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setIsOpen(false);
    setLoading(false);
  };

  const ConfirmationModal = () => (
    <EmailConfirmationModal
      open={isOpen}
      recipients={recipients}
      actionDescription={actionDesc}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
      loading={loading}
    />
  );

  return {
    showConfirmation,
    ConfirmationModal,
  };
}
